import { jsx as n, jsxs as i, Fragment as a } from "react/jsx-runtime";
import { I as t } from "../../../../icon-CEddREfQ.js";
const g = "_description_z23m2_66", b = "_name_z23m2_72", e = {
  "checkbox-contained": "_checkbox-contained_z23m2_29",
  "has-description": "_has-description_z23m2_62",
  description: g,
  name: b,
  "no-description": "_no-description_z23m2_80",
  "no-icon": "_no-icon_z23m2_86",
  "has-icon": "_has-icon_z23m2_89",
  "dialog-overlay-show": "_dialog-overlay-show_z23m2_1",
  "dialog-content-show": "_dialog-content-show_z23m2_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z23m2_1"
}, v = ({
  type: d = "checkbox",
  label: s,
  title: _,
  name: r,
  value: l = 1,
  checked: m,
  required: h = !1,
  onChange: p,
  icon: o,
  inputNumber: z = 0,
  description: c,
  id: x
}) => /* @__PURE__ */ n("div", { className: e["checkbox-contained"], children: /* @__PURE__ */ i(
  "label",
  {
    className: `${c ? e["has-description"] : e["no-description"]} ${o ? e["has-icon"] : e["no-icon"]}`,
    title: _,
    id: x,
    children: [
      /* @__PURE__ */ n(
        "input",
        {
          type: d,
          name: r,
          value: l,
          checked: m,
          onChange: p,
          required: h,
          "data-input-number": z
        }
      ),
      c ? /* @__PURE__ */ i(a, { children: [
        /* @__PURE__ */ i("div", { className: e.name, children: [
          o && /* @__PURE__ */ n(t, { name: o, size: "2xl" }),
          /* @__PURE__ */ n("span", { children: s })
        ] }),
        /* @__PURE__ */ n("div", { className: e.description, children: c })
      ] }) : /* @__PURE__ */ i(a, { children: [
        o && /* @__PURE__ */ n(t, { name: o, size: "2xl" }),
        /* @__PURE__ */ n("span", { children: s })
      ] })
    ]
  }
) });
export {
  v as CheckboxContained
};
